import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/modules/core/services/config.service';
import { LocaleService } from '../../../core/services/locale.service';
import { LanguageService } from '../../../core/services/language.service';
import { Observable } from 'rxjs';

export interface LanguageOption {
	[code: string]: string;
}

@Component({
	selector: 'cfe-language-switch',
	templateUrl: './language-switch.component.html',
	styleUrls: ['./language-switch.component.scss']
})
export class LanguageSwitchComponent implements OnInit {
	languageOptions: LanguageOption = this.configService.config?.languages || null;

	currentLanguage: Observable<string>;

	constructor(
		private localeService: LocaleService,
		private languageService: LanguageService,
		private configService: ConfigService
	) {}

	ngOnInit() {
		this.currentLanguage = this.languageService.language$;
	}

	setLanguage(language: string) {
		if (this.languageOptions[language]) {
			this.languageService.changeLanguage(language);
		}
	}

	// Get keys form object
	objectKeys(obj) {
		return obj ? Object.keys(obj) : [];
	}
}
